<template>
  <div v-if="srcs" class="slideshow-background">
    <div v-for="(url, index) in srcs" :data-visible="current === index" :style="'background-image:url(' + url + ')'"></div>
  </div>
</template>

<script>
export default {
  name: 'slideshowBackground',
  props: ['srcs'],
  data () {
    return {
      current: 0,
      autoplay: null
    }
  },
  methods: {
    play () {
      this.autoplay = setInterval(() => {
        this.current++
        this.current = this.current % this.srcs.length
      }, 3000)
    }
  },
  created () {
    this.play()
  },
  destroyed () {
    clearInterval(this.autoplay)
  }
}
</script>

<style lang="scss">
@import '../style/variables';
.slideshow-background{
  @include background(absolute,100%);
  overflow:hidden;
  > div{
    @include background(absolute,100%);
    @include transition(opacity .5s);
    opacity:0;
    &[data-visible]{
      opacity:1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// SlideshowBackground.vue?794a94b6